import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'

import fieldsService from '../../services/fields.service';

import { IChoiceField, IField, IProtocol, IProtocolsTableState, ISearchRequest, IUor, IUser, IVisibilita } from '../../shared/interfaces';

import { Selection, CommandBar, DefaultButton, DetailsHeader, IBasePickerSuggestionsProps, DetailsList, Text, DetailsListLayoutMode, IButtonProps, IColumn, ICommandBarItemProps, ICommandBarStyles, IDetailsListStyles, IDetailsRowProps, Label, Link, mergeStyleSets, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, TagPicker, ITag, IBasePicker, ScrollablePane, IScrollablePane, SearchBox, Icon, IPanelStyles, CheckboxVisibility, SelectionMode, IDetailsList, IDetailsColumnStyles, IDetailsColumnProps, TooltipHost, IContextualMenuItem, ContextualMenuItemType, ContextualMenu, IDropdownOption, Dropdown, IconButton, DirectionalHint, ITooltipHostStyles, ITextStyles, TooltipOverflowMode, IRenderFunction, IDetailsColumnFieldProps } from '@fluentui/react';
import { reduxActions, RootState } from '../../store';

import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';

import { Indici_FormMode, Protocol_State, RoleContext, Search_Type, Visibility_Type, Visibility_Type_Label } from '../../shared/enums';

import pdfImage from '../../assets/images/pdf.svg';

import DynamicForm from '../DynamicForm/DynamicForm';
import { checkRoles } from '../../hoc/CheckRoles';
import searchService from '../../services/search.service';
import AppUtilities from '../../shared/Utilities/appUtilities';
import uorsService from '../../services/uors.service';
import axios, { CancelTokenSource } from 'axios';
import CustomCommandBarButton from '../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { myTheme } from '../../assets/styles/my-theme';
import protocolsService from '../../services/protocols.service';
import { toastRef } from '../Layout/Layout';
import Utilities from '../../shared/Utilities/utilities';

const queryString = require('query-string');

const { palette } = myTheme;

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px',
    },
    selectionDetails: {
        marginBottom: '20px',
    },
    iconField: {
        padding: '5px',
        width: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'


    },
    emptyColumn: {

    }
});


const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    primarySet: {
        '& .ms-OverflowSet-item:first-of-type': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        },
    },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};

const detailsListStyles: Partial<IDetailsListStyles> = {
    root: {
        overflow: 'visible'
    }
}

const iconHeaderStyles: Partial<IDetailsColumnStyles> = {
    root: {
        width: '28px !important',
        padding: 0
    },
    cellTitle: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
    }

}
//const lastIconHeaderStyles: Partial<IDetailsColumnStyles> = {
//    root: {
//        width: '28px !important',
//        padding: 0
//    },
//    cellTitle: {
//        alignItems: 'center',
//        justifyContent: 'center',
//        padding: 0
//    }

//}


const mapState = (state: RootState) => ({
    currentUser: state.sessionReducer.currentUser,
    currentAoo: state.sessionReducer.currentAoo,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
})

const mapDispatch = {
    //    setProtocolsTableState: (protocolsTableState: (Partial<IProtocolsTableState>)) => (reduxActions.navigationProtocolsActions.setProtocolsTableState(protocolsTableState)),
    //    unsetProtocolsTableState: () => (reduxActions.navigationProtocolsActions.unsetProtocolsTableState()),
    //    updateNavigationProtocolsState: (state: NavigationProtocolsState) => (reduxActions.navigationProtocolsActions.updateNavigationProtocolsState(state))
    setProtocol: (protocol: IProtocol) => (reduxActions.appNavigationActions.setProtocol(protocol)),
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface SearchKQLComponentBaseState {
    searchPanelIsOpen: boolean;
    commandBarItems: ICommandBarItemProps[];
    farItems: ICommandBarItemProps[];
    columns: IColumn[];
    tableFields: IField[];
    searchFormFields: IField[];
    uorField: Partial<IField>;
    visibilitaField: Partial<IChoiceField>;
    items: (IProtocol | null)[];
    totalRows: number;
    protocolsRequest: ISearchRequest;
    isLoadingProtocols: boolean;
    messageBarIsVisible: boolean;
    messageBarType: MessageBarType | undefined;
    messageBarText: string;
    selectedTags: any[];
    globalSearchValue: string;
    selectedProtocol?: IProtocol
    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    contextMenuPosition: any
}
export interface SearchKQLComponentBaseProps {
    protocolsTableState?: Partial<IProtocolsTableState>
    updateProtocolsTableState?: (protocolsTableState: Partial<IProtocolsTableState>) => void
    searchBaseWillUnmount?: () => void
}

type Props = SearchKQLComponentBaseProps & RouteComponentProps & PropsFromRedux

class SearchKQLComponentBase extends React.Component<Props, SearchKQLComponentBaseState> {

    tagPickerRef = React.createRef<IBasePicker<ITag>>();
    detailsListRef = React.createRef<IDetailsList>();
    cancelTokenSources = {};
    private protocolSelection: Selection;

    constructor(props) {
        super(props);

        this.protocolSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.protocolSelection.getSelection()[0] as IProtocol;
                this.setState({ selectedProtocol: selection });
            },
        });


        this.state = {
            searchPanelIsOpen: false,
            commandBarItems: [],
            farItems: [],
            items: [],
            totalRows: 0,
            columns: [],
            tableFields: [],
            searchFormFields: [],
            uorField: {
                displayName: "Uor",
                internalName: "uor",
                controlType: "autocomplete",
                required: false,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: '',
                valid: false,
                touched: false,

            },
            visibilitaField: {
                displayName: "Tipo visibilità",
                internalName: "visibilityType",
                controlType: "dropdown",
                required: false,
                readonly: false,
                disabled: false,
                system: false,
                valid: false,
                touched: false,
                multi: false,
                options: [
                    { text: Visibility_Type_Label.get(Visibility_Type.Proprietario), key: Visibility_Type.Proprietario },
                    { text: Visibility_Type_Label.get(Visibility_Type.Inoltro), key: Visibility_Type.Inoltro },
                    { text: "Visibilit\u00e0", key: Visibility_Type.Visibilita },
                    { text: Visibility_Type_Label.get(Visibility_Type.CopiaConoscenza), key: Visibility_Type.CopiaConoscenza },
                ] as IDropdownOption[]
            },
            isLoadingProtocols: true,
            protocolsRequest: { fields: [], startRow: 0 } as ISearchRequest,
            messageBarIsVisible: false,
            messageBarType: undefined,
            messageBarText: '',
            selectedTags: [],
            globalSearchValue: '',
            showContextualMenu: false,
            contextMenuItems: [],
            contextMenuPosition: undefined
        };
    }
    componentDidMount() {
        this.updateCommandBarItems();
        //se non ho tableFields significa che lo stato salvato è parziale (es. switch pagina prima della response)
        if (this.props.protocolsTableState && this.props.protocolsTableState.tableFields && this.props.protocolsTableState.tableFields.length > 0) {
            this.restoreState();
        }
        else if (this.props.currentAoo) {
            this.getFieldsAndProtocols()
        }
    }

    componentDidUpdate(oldProps, oldstate: SearchKQLComponentBaseState) {
        if (oldProps.currentAoo !== this.props.currentAoo) {
            let { protocolsRequest } = this.state
            protocolsRequest.startRow = 0;
            this.setState({
                items: [],
                protocolsRequest: protocolsRequest,
            }, this.getFieldsAndProtocols);
        }
        if (oldstate.protocolsRequest !== this.state.protocolsRequest || oldstate.selectedProtocol !== this.state.selectedProtocol) {
            this.updateCommandBarItems();
        }


    }

    componentWillUnmount() {
        this.saveState();
        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
        if (this.props.searchBaseWillUnmount) {
            this.props.searchBaseWillUnmount();
        }
    }

    saveState = () => {
        if (this.props.updateProtocolsTableState) {
            let startItemIndexInView = this.detailsListRef.current?.getStartItemIndexInView();
            let { commandBarItems, messageBarIsVisible, messageBarText, messageBarType, isLoadingProtocols,
                ...protocolsTableState } = this.state;
            if (!protocolsTableState.items || protocolsTableState.items.length === 0) {
                protocolsTableState.items = [null];
            }
            this.props.updateProtocolsTableState({ ...protocolsTableState, startItemIndexInView: startItemIndexInView });
        }
    }


    //saveScrollPosition = () => {

    //    const el = document.getElementById('scroll');
    //    const scrollPanel = el?.querySelectorAll(".p-scrollpanel-content")[0];
    //    let scrollTop = scrollPanel?.scrollTop;


    //    this.props.setProtocolsTableState({ scrollTop: scrollTop! })
    //}




    restoreState = () => {

        let storedState = { ...this.props.protocolsTableState }

        this.setState({
            columns: storedState.columns!,
            globalSearchValue: storedState.globalSearchValue!,
            items: storedState.items!,
            protocolsRequest: storedState.protocolsRequest!,
            searchFormFields: storedState.searchFormFields!,
            selectedTags: storedState.selectedTags!,
            tableFields: storedState.tableFields!,
            uorField: storedState.uorField!,
            visibilitaField: storedState.visibilitaField!,
            isLoadingProtocols: false,
            totalRows: storedState.totalRows!


        }, () => {
            setTimeout(() => {
                this.detailsListRef.current?.focusIndex(storedState.startItemIndexInView ?? 0);
                this.updateCommandBarItems();
            }, 100);
        })
        //this.props.updateNavigationProtocolsState({ protocolsTableState: undefined });

        if (!storedState.searchFormFields || storedState.searchFormFields.length === 0) {
            this.getSearchFormFields();
        }
    }

    updateCommandBarItems = () => {
        let { currentUser, currentAoo } = this.props;
        let newCommandBarItems: ICommandBarItemProps[] = [];

        newCommandBarItems.push(
            {
                key: 'filtri',
                commandBarButtonAs: () => (

                    <CustomCommandBarButton
                        asDefaultButton={true}
                        text='Filtri'
                        key='Filtri'
                        iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                        onClick={this.openSearchPanel}
                    />

                )
            }
        );

        if (this.state.protocolsRequest.globalSearch || (this.state.protocolsRequest.fields && this.state.protocolsRequest.fields.length >= 0)) {
            newCommandBarItems.push({
                key: 'resetFiltri',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Reset filtri'
                        key='resetFiltri'
                        iconPropsFontAwesome={{ icon: ['fal', 'filter-slash'] }}
                        onClick={this.resetSearchHandler}
                    />
                )
            });
            //    newCommandBarItems.push({
            //        key: 'test',
            //        commandBarButtonAs: () => (
            //            <div ><span>TEST</span></div>

            //        )
            //    });
        }






        if (this.state.selectedProtocol) {
            if (this.state.selectedProtocol.hasAttachments) {
                newCommandBarItems.push({
                    key: 'downloadAll',
                    text: 'Scarica tutto',
                    iconProps: { iconName: 'Download' },
                    onClick: this.onDownloadAllButtonClick
                });
            }


            // ricavo le uor in cui l'utente corrente ha ruolo Operatore
            const userOperatoreUor = currentUser?.ruoliUorContext.reduce((a: IUor[], o) => (o.uor && o.uor.aooId === currentAoo?.id && o.ruolo && o.ruolo.nome === "Operatore" && a.push(o.uor), a), []) ?? [];

            // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
            // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
            // creare il protocollo

            if (userOperatoreUor.length > 0) {
                newCommandBarItems.push({
                    key: 'createFrom',
                    text: 'Crea da',
                    iconProps: { iconName: 'Copy' },
                    onClick: this.createProtocolFromHandler
                });
            }


        }

        this.setState({ commandBarItems: newCommandBarItems })
    }

    getFieldsAndProtocols = (oldProps?) => {
        if (this.props.currentAoo) {
            this.setState({ isLoadingProtocols: true })

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[fieldsService.getFieldsByViewName.name]?.cancel("Request annullata");
            this.cancelTokenSources[searchService.search.name]?.cancel("Request annullata");

            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[fieldsService.getFieldsByViewName.name] = axios.CancelToken.source();

            fieldsService
                .getFieldsByViewName(this.props.currentAoo.id, "Tutti i protocolli", this.cancelTokenSources[fieldsService.getFieldsByViewName.name].token)
                .then(fields => {
                    let _fields = fields.filter(f => !f.system && f.internalName !== 'Title' && f.internalName !== 'ID');

                    let newColumns: IColumn[] = [
                        {
                            key: 'visibilita',
                            name: 'visibilita',
                            fieldName: 'visibilita',
                            isIconOnly: true,
                            styles: iconHeaderStyles,
                            minWidth: 6,
                            maxWidth: 6,
                            onRenderField: this.onRenderVisibilitaField
                        },
                        {
                            key: 'attachment',
                            name: 'attachment',
                            fieldName: 'attachments',
                            isIconOnly: true,
                            styles: iconHeaderStyles,
                            minWidth: 7,
                            maxWidth: 7,
                            onRenderField: this.onRenderAttachmentField,
                            onRenderHeader: () => {
                                return <Icon iconName="Attach" className={classNames.fileIconHeaderIcon} />
                            },

                        },
                        {
                            key: 'statoProtocolloIcon',
                            name: 'statoProtocolloIcon',
                            fieldName: 'StatoProtocollo',
                            isIconOnly: true,
                            styles: iconHeaderStyles,
                            minWidth: 9,
                            maxWidth: 9,
                            onRenderField: this.onRenderStatoProtocolloField,
                            onRenderHeader: () => {
                                return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} className={classNames.fileIconHeaderIcon} />
                            }

                        },

                    ];


                    _fields.forEach(field => {
                        let col: IColumn = {
                            key: field.internalName,
                            fieldName: field.internalName,
                            name: field.displayName,
                            minWidth: 150,
                            isResizable: true,
                            ...field
                        };
                        if (field.internalName === 'Protocollo' || field.internalName === 'DataProtocollo' || field.internalName === 'StatoProtocollo') {
                            col.maxWidth = 110;
                            col.minWidth = 110;
                        } else if (field.internalName === "TipoProtocollo") {
                            col.maxWidth = 140;
                            col.minWidth = 140;
                        }
                        newColumns.push(col);
                    });
                    /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamento tra
                    /// l'header e i contenuti della tabella 
                    if (!this.props.isMobile) {
                        newColumns.push(
                            {
                                key: 'empty',
                                name: 'empty',
                                fieldName: 'empty',
                                isIconOnly: true,

                                className: classNames.emptyColumn,
                                headerClassName: classNames.emptyColumn,
                                minWidth: 1,
                                maxWidth: 1,
                                onRender: (item) => { },
                            },

                        );
                    }
                    let fixedFields = AppUtilities.fixFieldsForm(Indici_FormMode.Search, _fields);

                    this.setState({
                        columns: newColumns,
                        tableFields: fixedFields
                    }, () => { this.saveState() });

                    this.getProtocols({
                        startRow: 0,
                        searchType: Search_Type.Protocollo
                    });
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else {
                        throw error;
                    }
                });


            this.getSearchFormFields();
        }
    }
    onRenderVisibilitaField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item) {
            let item = columnProps.item
            let uorField = this.state.uorField;
            let visibilitaField = this.state.visibilitaField;
            const arrayVisibilita = item.visibilita;

            if (visibilitaField.internalValue !== undefined && visibilitaField.internalValue !== null) {
                return this.renderVisibilitaIconByType(visibilitaField.internalValue);

            }
            else if (uorField.internalValue && uorField.internalValue.length > 0) {
                let uorId = uorField.internalValue[0].key;
                const visibilitaUor: IVisibilita = arrayVisibilita.find(r => r.uor.id === uorId);
                return this.renderVisibilitaIconByType(visibilitaUor.tipologia);

            }
            else {
                // Con questo metodo faccio il render dell'icona della visibilità che l'utente ha sul protocollo.
                // Visualizzo solo una delle visibilità che l'utente può avere, la più importante secondo questo ordine:
                // Proprietario, Inoltro, CopiaConoscenza, Visibilità
                if (item.visibilita) {
                    // ricavo i ruoli dell'utente corrente nell'aoo corrente
                    const ruoliUtenteCurrentAoo = this.props.currentUser?.ruoliUorContext.filter(r => r.uor && r.uor.aooId === this.props.currentAoo?.id);

                    // ricavo la uor proprietaria del protocollo
                    const proprietario = arrayVisibilita.find(r => r.tipologia === Visibility_Type.Proprietario);
                    if (proprietario !== undefined && ruoliUtenteCurrentAoo !== undefined) {
                        // se l'utente ha almeno un ruolo attivo nella uor proprietaria del protocollo
                        // faccio il render  dell'icona del proprietario
                        // altrimenti procedo con il check tra le uor in inoltro
                        const isUtenteProprietario = ruoliUtenteCurrentAoo.some(r => r.uorId === proprietario.uor.id);
                        if (isUtenteProprietario) {
                            return this.renderProprietarioIcon()
                        }
                    }

                    // ricavo le uor che hanno il protocollo in inoltro 
                    const inoltri = arrayVisibilita.filter(r => r.tipologia === Visibility_Type.Inoltro);
                    if (inoltri !== undefined && ruoliUtenteCurrentAoo !== undefined) {
                        // se l'utente ha almeno un ruolo attivo in una delle uor che hanno il protocollo in inoltro
                        // faccio il render  dell'icona dell'inoltro
                        // altrimenti procedo con il check tra le uor in copia conoscenza
                        const isUtenteInInoltro = ruoliUtenteCurrentAoo.some(r => inoltri.some(v => v.uor.id === r.uorId));
                        if (isUtenteInInoltro) {
                            return this.renderInoltroIcon()
                        }
                    }

                    // ricavo le uor che hanno il protocollo in copia conoscenza 
                    const copiaConoscenza = arrayVisibilita.filter(r => r.tipologia === Visibility_Type.CopiaConoscenza);
                    if (copiaConoscenza !== undefined && ruoliUtenteCurrentAoo !== undefined) {
                        // se l'utente ha almeno un ruolo attivo in una delle uor che hanno il protocollo in copia conoscenza
                        // faccio il render  dell'icona della copia conoscenza
                        // altrimenti procedo con il check tra le uor in visibilità
                        const isUtenteInCopiaConoscenza = ruoliUtenteCurrentAoo.some(r => copiaConoscenza.some(v => v.uor.id === r.uorId));
                        if (isUtenteInCopiaConoscenza) {
                            return this.renderCopiaConoscenzaIcon()
                        }
                    }
                    // ricavo le uor che hanno il protocollo in visibilità
                    const visibilita = arrayVisibilita.filter(r => r.tipologia === Visibility_Type.Visibilita);
                    if (visibilita !== undefined && ruoliUtenteCurrentAoo !== undefined) {
                        // se l'utente ha almeno un ruolo attivo in una delle uor che hanno il protocollo in cvisibilità
                        // faccio il render  dell'icona della visibilità
                        // altrimenti lascio la colonna vuota (caso supervisore)
                        const isUtenteInVisibilita = ruoliUtenteCurrentAoo.some(r => visibilita.some(v => v.uor.id === r.uorId));
                        if (isUtenteInVisibilita) {
                            return this.renderVisibilitaIcon()
                        }
                    }
                }
            }
        }
        return <div></div>
    }
    private renderVisibilitaIconByType(visibilitaTipo: Visibility_Type) {
        switch (visibilitaTipo) {

            case Visibility_Type.Proprietario:
                return this.renderProprietarioIcon();

            case Visibility_Type.Inoltro:
                return this.renderInoltroIcon();

            case Visibility_Type.CopiaConoscenza:
                return this.renderCopiaConoscenzaIcon();

            case Visibility_Type.Visibilita:
                return this.renderVisibilitaIcon();
            default:
                return <div className={classNames.iconField} ></div>;

        }

    }

    private renderVisibilitaIcon() {
        return (
            <div className={classNames.iconField} >
                <TooltipHost content="Visibilità" id={"tooltipVisibilita"}>
                    <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fal', iconName: 'eye' }} style={{ fontSize: 16, color: palette.themePrimary }} />
                </TooltipHost>
            </div>
        );
    }

    private renderCopiaConoscenzaIcon() {
        return (
            <div className={classNames.iconField} >
                <TooltipHost content="Copia Conoscenza" id={"tooltipCopiaConoscenza"}>
                    <Icon iconName="Accounts" style={{ fontSize: 16, color: palette.themePrimary }} />
                </TooltipHost>
            </div>
        );
    }

    private renderInoltroIcon() {
        return (
            <div className={classNames.iconField} >
                <TooltipHost content="Inoltro" id={"tooltipInoltro"}>
                    <Icon iconName="FastForward" style={{ fontSize: 16, color: palette.themePrimary }} />
                </TooltipHost>
            </div>
        );
    }

    private renderProprietarioIcon() {
        return (
            <div className={classNames.iconField} >
                <TooltipHost content="Proprietario" id={"tooltipProprietario"}>
                    <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fal', iconName: 'user-tie' }} style={{ fontSize: 16, color: palette.themePrimary }} />
                </TooltipHost>
            </div>
        );
    }

    onRenderAttachmentField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.hasAttachments) {
            return (
                <div className={classNames.iconField} >
                    <TooltipHost content="Allegato">
                        <Icon iconName="Attach" style={{ fontSize: 16 }} />
                    </TooltipHost>
                </div>);
        }
        return <div className={classNames.iconField} ></div>;
    }
    onRenderStatoProtocolloField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.statoProtocollo === Protocol_State.Annullato) {
            return (
                <div className={classNames.iconField} >
                    <TooltipHost content="Annullato">
                        <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} style={{ fontSize: 16 }} />
                    </TooltipHost>
                </div>
            );

        }
        return <div className={classNames.iconField} ></div>;
    }
    onRenderDocumentField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.statoProtocollo !== Protocol_State.InCreazione && columnProps.item.statoProtocollo !== Protocol_State.InCreazioneDaMail) {
            return (
                <div className={classNames.iconField} >
                    <img src={pdfImage} className={classNames.fileIconImg} alt="Documento" />
                </div>);
        }
        return <div className={classNames.iconField} ></div>;
    }


    getSearchFormFields = () => {
        fieldsService
            .getFieldsByViewName(this.props.currentAoo!.id, "Campi ricerca", this.cancelTokenSources[fieldsService.getFieldsByViewName.name].token)
            .then(fields => {
                let fixedFields = AppUtilities.fixFieldsForm(Indici_FormMode.Search, fields);

                this.setState({
                    searchFormFields: fixedFields
                }, () => { this.saveState() });

            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else {
                    throw error;
                }
            });
        ;
    }

    getProtocols = (searchRequest: ISearchRequest) => {
        // if (!this.state.isLoadingProtocols) {
        //     this.setState({ isLoadingProtocols: true })

        if (this.props.currentAoo) {
            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[searchService.search.name]?.cancel("Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[searchService.search.name] = axios.CancelToken.source();

            searchService
                .search(this.props.currentAoo.id, searchRequest, this.cancelTokenSources[searchService.search.name].token)
                .then(result => {

                    let items: (IProtocol | null)[] = result.protocols;

                    let protocolsRequest = { ...searchRequest }

                    let currentItems = [...this.state.items, ...items];
                    if (currentItems.length < result.totalRows) {
                        protocolsRequest.startRow = currentItems.length;

                        currentItems.push(null); //aggiungo un item null così DetailsList capisce che deve chiamare il metodo onRenderMissingItem
                    }

                    this.setState({
                        items: [...currentItems],
                        protocolsRequest: protocolsRequest,
                        isLoadingProtocols: false,
                        totalRows: result.totalRows,
                    }, () => { this.saveState() });
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }
                    this.setState({
                        items: [],
                        isLoadingProtocols: false
                    }, () => { this.saveState() });
                });
        }
        // }
    }

    globalSearch = (searchRequest: ISearchRequest) => {
        if (this.props.currentAoo) {
            this.getProtocols(searchRequest);
        }
    }

    globalSearchSubmit = (searchValue) => {
        this.resetSearchFields();

        if (searchValue === '') {
            return;
        } else {
            this.setState({
                isLoadingProtocols: true,
                items: []
            }, () => { this.saveState() });

            this.globalSearch({
                startRow: 0,
                globalSearch: searchValue!,
            })
        }
    }

    tagPickerSuggestionsProps: IBasePickerSuggestionsProps = {
        suggestionsHeaderText: 'Suggerimenti',
        mostRecentlyUsedHeaderText: 'Utenti suggeriti',
        noResultsFoundText: 'Nessun risultato trovato',
        loadingText: 'Caricamento',
        showRemoveButtons: false,
    };

    onTagPickerFilterChanged = async (
        filterText: string,
        currentTags?: ITag[],
    ): Promise<ITag[]> => {
        if (filterText) {
            let filteredSuggestions = await this.searchLookupSuggestions(filterText);

            if (currentTags)
                filteredSuggestions = this.removeTagPickerDuplicates(filteredSuggestions, currentTags);

            return filteredSuggestions;
        } else {
            return [];
        }
    };


    searchLookupSuggestions = async (filterText: string): Promise<ITag[]> => {
        let result: ITag[] = [];
        let { currentAoo } = this.props;
        if (currentAoo && filterText) {
            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[uorsService.getUorSuggestionsForCurrentUser.name]?.cancel("Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[uorsService.getUorSuggestionsForCurrentUser.name] = axios.CancelToken.source();

            await uorsService.getUorSuggestionsForCurrentUser(currentAoo.id, filterText, this.cancelTokenSources[uorsService.getUorSuggestionsForCurrentUser.name].token)
                .then(suggestions => {
                    result = suggestions.reduce((a: ITag[], o) => (o && a.push({ key: o.id!, name: o.nome! }), a), [])
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else {
                        throw error;
                    }
                });
        }

        return result;

    }

    removeTagPickerDuplicates = (items: ITag[], possibleDupes: ITag[]) => {
        return items.filter(persona => possibleDupes.findIndex(el => el.key === persona.key) < 0);
    }

    onTagSelected = (selectedItem: any): ITag | null => {
        // restituendo null il component non aggiunge nessun elemento alla selezione e riesco a controllare
        // gli elementi selezionati tramiteinputChanged(selectedItem) che setta l'internalValue del campo
        return selectedItem;
    }
    onTagPickerItemsChange = (items?: any[]): void => {
        this.setState({
            uorField: { ...this.state.uorField, internalValue: items }
        }, () => { this.saveState() });
    };

    //metodi per selection visibilita
    onDropdownSelectChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        if (option) {
            this.setState({
                visibilitaField: { ...this.state.visibilitaField, internalValue: option.key }
            }, () => { this.saveState() });

        }
    }

    onCleanDropdownButton = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            visibilitaField: { ...this.state.visibilitaField, internalValue: null }
        }, () => { this.saveState() });
    }

    onRenderDropodownTitle = (options: IDropdownOption<IVisibilita>[] | undefined): JSX.Element => {
        const option = options![0];

        return (
            <div>
                <span>{option.text}
                    <IconButton
                        iconProps={{ iconName: 'Cancel' }}
                        styles={{ root: { height: 20, width: 20, verticalAlign: 'text-top' } }}
                        onClick={this.onCleanDropdownButton} />
                </span>
            </div>
        );
    };

    openSearchPanel = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({ searchPanelIsOpen: true })
    }

    dismissSearchPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ searchPanelIsOpen: false })
    }

    onSubmitGlobalSearch = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        ev.preventDefault();
        ev.stopPropagation();
        let searchValue = this.state.globalSearchValue;
        this.globalSearchSubmit(searchValue)
    }


    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (

            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    onRenderMissingItem = (index?: number | undefined, rowProps?: IDetailsRowProps | undefined): null => {
        let currentItems = this.state.items.slice();
        currentItems.pop();
        this.setState({
            items: currentItems
        }, () => { this.getProtocols(this.state.protocolsRequest) })
        return null;
    };

    indiciInputChangedHandler = (newField: IField) => {

        const updatedFormFields: IField[] = [...this.state.searchFormFields];
        let itemIndex = updatedFormFields.findIndex(el => el.internalName === newField.internalName);
        // se l'internalValue è null setto field.touched a false così viene ignorato durante la ricerca
        if (!newField.internalValue) {
            updatedFormFields[itemIndex] = { ...newField, touched: false };
        } else {
            updatedFormFields[itemIndex] = { ...newField };
        }
        this.setState({
            searchFormFields: updatedFormFields
        }, () => { this.saveState() });

    }

    resetSearchHandler = () => {
        let { searchFormFields, uorField, visibilitaField } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({
            searchFormFields: newSearchFields,
            uorField: { ...uorField, internalValue: [] },
            visibilitaField: { ...visibilitaField, internalValue: null },
            globalSearchValue: '',
            isLoadingProtocols: true,
            items: [null],
            protocolsRequest: {
                startRow: 0,
                searchType: Search_Type.Protocollo
            }
        }, () => { this.saveState() });
    }

    resetSearchFields = () => {
        let { searchFormFields, uorField, visibilitaField } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({
            searchFormFields: newSearchFields,
            uorField: { ...uorField, internalValue: [] },
            visibilitaField: { ...visibilitaField, internalValue: null }
        }, () => { this.saveState() });
    }

    // Click su salva del panel laterale
    searchLateralPanelSubmit = () => {
        this.setState({
            globalSearchValue: '',
            searchPanelIsOpen: false,
            isLoadingProtocols: true,
            items: []
        }, () => { this.saveState() });

        let { searchFormFields } = this.state;

        let touchedFields: IField[] = searchFormFields.filter((el: IField) => el.touched && el.internalValue);
        let fixedFields = AppUtilities.fixFieldsInternalValueForSearchSubmit([...touchedFields]);

        this.getProtocols({
            fields: fixedFields,
            startRow: 0,
            uor: this.state.uorField.internalValue && this.state.uorField.internalValue.length > 0 ? { id: this.state.uorField.internalValue[0].key, nome: this.state.uorField.internalValue[0].name } : undefined,
            visibilitaSP_Type: this.state.visibilitaField.internalValue ? this.state.visibilitaField.internalValue : undefined,
            searchType: Search_Type.Protocollo
        });
    }

    createProtocolFromHandler = () => {

        this.props.history.push({ pathname: `/${this.props.currentAoo?.id}/createfrom/${this.state.selectedProtocol!.id}`, search: this.props.location.search });

    }

    onDownloadAllButtonClick = () => {
        let { currentAoo, location, currentUser } = this.props;
        const parsedQueryString = queryString.parse(location.search);

        if (currentAoo && currentUser && this.state.selectedProtocol) {
            let protocolId = this.state.selectedProtocol.id!;
            let visibilitaProtocollo = this.state.selectedProtocol.visibilita;
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            if (uorId === undefined && visibilitaProtocollo) {

                uorId = this.getUorUtenteConVisibilitaPiuImportante(visibilitaProtocollo, currentUser, currentAoo.id);
            }

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name]?.cancel(protocolsService.getProtocolFilesAsZip.name + " Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name] = axios.CancelToken.source();

            toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Avviato il download degli allegati`, life: 5000 });

            protocolsService
                .getProtocolFilesAsZip(currentAoo.id, uorId, protocolId, this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name].token)
                .then(zipFile => {
                    toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Download degli allegati completato con successo`, life: 5000 });

                    let fileBase64string = zipFile.docBase64String;
                    let fileName = zipFile.fileName;
                    if (fileBase64string && fileName) {
                        Utilities.SaveFileFromBase64(fileBase64string, fileName);
                    }
                })
                .catch(error => {

                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download degli allegati`, life: 5000 });

                    } else {
                        throw error;
                    }

                });
        };
    }

    getUorUtenteConVisibilitaPiuImportante = (visibilitaProtocollo: IVisibilita[], currentUser: IUser, currentAooId: number): number | undefined => {
        // Questo metodo determina la UOR con la visibilità più alta a cui l'utente ha accesso.
        // L'ordine di importanza della visibilità è: Proprietario, Inoltro, CopiaConoscenza, Visibilità.

        // ricavo i ruoli dell'utente corrente nell'aoo corrente
        const ruoliUtenteCurrentAoo = currentUser.ruoliUorContext.filter(r => r.uor && r.uor.aooId === currentAooId);
        if (ruoliUtenteCurrentAoo) {
            // Ottengo la UOR proprietaria del protocollo se è presente tra le UOR in cui l'utente ha un ruolo.   
            const proprietario = visibilitaProtocollo.find(
                vis => vis.tipologia === Visibility_Type.Proprietario
                    && ruoliUtenteCurrentAoo.some(r => r.uorId === vis.uor.id)
            );

            if (proprietario !== undefined) {
                return proprietario.uor.id
            }


            // Ottengo la prima UOR in inoltro se è presente tra le UOR in cui l'utente ha un ruolo.   
            const inoltro = visibilitaProtocollo.find(
                vis => vis.tipologia === Visibility_Type.Inoltro
                    && ruoliUtenteCurrentAoo.some(r => r.uorId === vis.uor.id)
            );
            if (inoltro !== undefined) {
                return inoltro.uor.id
            }


            // Ottengo la prima UOR in copia conoscenza se è presente tra le UOR in cui l'utente ha un ruolo.
            const copiaConoscenza = visibilitaProtocollo.find(
                vis => vis.tipologia === Visibility_Type.CopiaConoscenza
                    && ruoliUtenteCurrentAoo.some(r => r.uorId === vis.uor.id)
            );
            if (copiaConoscenza !== undefined) {
                return copiaConoscenza.uor.id
            }

            // Ottengo la prima UOR in visibilità se è presente tra le UOR in cui l'utente ha un ruolo.
            const visibilita = visibilitaProtocollo.find(
                vis => vis.tipologia === Visibility_Type.Visibilita
                    && ruoliUtenteCurrentAoo.some(r => r.uorId === vis.uor.id)
            );
            if (visibilita !== undefined) {
                return visibilita.uor.id
            }
        }
        return undefined;
    }

    dismissMessageBar = () => {
        this.setState({ messageBarIsVisible: false })
    }

    navigate = (ev, item?: IProtocol) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        if (item && item.id) {
            this.props.setProtocol(item!);

            //aggiunge gli zeri prima del numero
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = zeroPad(item.numeroProtocollo, 8) + '-' + item.annoProtocollo;

            let proprietario = item.visibilita!.find(v => v.tipologia === Visibility_Type.Proprietario);
            let uorIdProprietario = proprietario?.uor.id;


            let _pathname;
            let _search = this.props.location.search;
            let _parsedQueryString;
            switch (item.statoProtocollo) {
                case Protocol_State.Protocollato:
                case Protocol_State.Acquisito:
                case Protocol_State.Annullato:
                    _pathname = `/${this.props.currentAoo!.id}/${item.id}/${protocolnumber}`;
                    break;
                case Protocol_State.Allocato:
                    _pathname = `/${this.props.currentAoo!.id}/allocated/${item.id}/${protocolnumber}`;
                    _parsedQueryString = queryString.parse(_search);
                    _parsedQueryString.uorId = uorIdProprietario;
                    _search = queryString.stringify(_parsedQueryString);

                    break;
                case Protocol_State.InCreazione:
                case Protocol_State.InCreazioneDaMail:
                    _pathname = `/${this.props.currentAoo!.id}/edit/${item.id}`;
                    _parsedQueryString = queryString.parse(_search);
                    _parsedQueryString.uorId = uorIdProprietario;
                    _search = queryString.stringify(_parsedQueryString);

                    break;

            }
            this.props.history.push({ pathname: _pathname, search: _search });
        }
    }

    onSelectProtocolHandler = (selected) => {
        this.setState({
            selectedProtocol: selected
        })
    }

    onRenderItemColumn = (item?: IProtocol, index?: number | undefined, column?) => {
        let displayValue = "-";
        let columnContent: any | undefined;
        ({ displayValue, columnContent } = this.extractDisplayValueAndColumnContent(item, column));

        return (
            <TooltipHost
                content={displayValue}
                styles={tooltipHostStyles}
                overflowMode={TooltipOverflowMode.Self}
            >
                {columnContent}
            </TooltipHost>
        );
    }

    extractDisplayValueAndColumnContent = (item: IProtocol | undefined, column: any) => {
        let displayValue = "-";
        let columnInternalName = column?.fieldName;

        let columnContent: any = displayValue;

        if (item) {
            let protocol: IProtocol = { ...item };
            const fieldContent = protocol.fields?.find(it => it.internalName === columnInternalName);
            if (fieldContent) {
                const fieldColumnMerge: IField = { ...column, internalValue: fieldContent?.internalValue };
                displayValue = AppUtilities.getDisplayValueFromFieldControlType(fieldColumnMerge);
                if (columnInternalName === 'Protocollo') {
                    if (protocol.statoProtocollo === Protocol_State.InCreazione || protocol.statoProtocollo === Protocol_State.InCreazioneDaMail) {
                        displayValue = "Bozza";
                    }
                    columnContent = (
                        <Link onClick={(ev) => this.navigate(ev, item)}>{displayValue}</Link>
                    );
                }
                else {
                    columnContent = displayValue;
                }
            }
        }
        return { displayValue, columnContent };
    }


    onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Cerca"
                    onClick={this.searchLateralPanelSubmit}

                />
                <DefaultButton
                    onClick={() => this.resetSearchFields()}
                    text="Reset filtri"
                />
            </React.Fragment>
        );
    }

    // metodi gestione context menu 
    onShowContextualMenu = (item, index, ev) => {
        ev.preventDefault();
        let { currentUser, currentAoo } = this.props;
        const menuItems: IContextualMenuItem[] = [
            {
                key: 'open',
                text: 'Apri documento',
                iconProps: { iconName: 'Document' },
                onClick: () => {
                    this.navigate(ev, item);
                    this.onHideContextualMenu();
                }
            },
        ];

        if (item.hasAttachments) {

            menuItems.push(
                {
                    key: 'downloadAll',
                    text: 'Scarica tutto',
                    iconProps: { iconName: 'Download' },
                    onClick: () => {
                        this.onDownloadAllButtonClick();
                        this.onHideContextualMenu();
                    }
                }
            );
        }


        // ricavo le uor in cui l'utente corrente ha ruolo Operatore
        const userOperatoreUor = currentUser?.ruoliUorContext.reduce((a: IUor[], o) => (o.uor && o.uor.aooId === currentAoo?.id && o.ruolo && o.ruolo.nome === "Operatore" && a.push(o.uor), a), []) ?? [];

        // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
        // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
        // creare il protocollo

        if (userOperatoreUor.length > 0) {
            menuItems.push(
                {
                    key: 'createFrom',
                    text: 'Crea da',
                    iconProps: { iconName: 'Copy' },
                    onClick: () => {
                        this.createProtocolFromHandler();
                        this.onHideContextualMenu();
                    }
                }
            );
        }


        this.setState({ contextMenuItems: menuItems, showContextualMenu: true, contextMenuPosition: ev });
    };

    onHideContextualMenu = () => {
        this.setState({ contextMenuItems: undefined, showContextualMenu: false });
    };





    public render() {
        var searchMessage;
        var uorInSearchMessage = this.state.uorField.internalValue.length === 1 ? this.state.uorField.internalValue[0].name : undefined;
        if (this.state.protocolsRequest.globalSearch || (this.state.protocolsRequest.fields && this.state.protocolsRequest.fields.length >= 0)) {
            searchMessage = this.state.totalRows === 1 ? 'La ricerca ha prodotto 1 risultato' : `La ricerca ha prodotto ${this.state.totalRows} risultati`;
            if (this.state.uorField.internalValue.length > 0) {
                searchMessage += ` per ${uorInSearchMessage}`;
            }
        }
        return (
            <div className="search-component">
                <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocols} />

                <CommandBar
                    overflowButtonProps={overflowProps}
                    items={this.state.commandBarItems}
                    farItems={this.state.farItems}
                    styles={commandBarStyles}

                />
                {(searchMessage) &&
                    <Text block style={{ padding: "13px 25px 13px 29px" }}>{searchMessage}</Text>
                }


                {this.state.items.length > 0 &&
                    <DetailsList
                        className="with-empty-column"
                        styles={detailsListStyles}
                        componentRef={this.detailsListRef}
                        items={this.state.items}
                        columns={this.state.columns}
                        onRenderItemColumn={this.onRenderItemColumn}
                        onRenderDetailsHeader={this.onRenderDetailsHeader}
                        onRenderMissingItem={this.onRenderMissingItem}
                        layoutMode={DetailsListLayoutMode.justified}
                        selection={this.protocolSelection}
                        selectionPreservedOnEmptyClick={true}
                        selectionMode={SelectionMode.single}
                        checkboxVisibility={CheckboxVisibility.onHover}
                        onItemContextMenu={this.onShowContextualMenu}
                    />
                }
                {this.state.items.length === 0 &&

                    <Text block style={{ padding: 25 }}>Nessun risultato trovato.</Text>
                }

                <ContextualMenu
                    items={this.state.contextMenuItems!}
                    hidden={!this.state.showContextualMenu}
                    target={this.state.contextMenuPosition}
                    onItemClick={this.onHideContextualMenu}
                    onDismiss={this.onHideContextualMenu}
                />

                <Panel
                    isLightDismiss
                    isOpen={this.state.searchPanelIsOpen}
                    type={PanelType.custom}
                    customWidth={'600px'}
                    headerText={'Filtri di ricerca'}
                    id={'searchFormPanel'}  // l'ID 'searchFormPanel' viene usato nel component INPUT per gestire il click esterno al calendario
                    onDismiss={this.dismissSearchPanel}
                    onRenderFooterContent={this.onRenderLateralPanelFooterContent}

                    closeButtonAriaLabel="Close"
                    isHiddenOnDismiss={false}
                >
                    {this.state.messageBarIsVisible &&
                        <MessageBar
                            messageBarType={this.state.messageBarType}
                            isMultiline={false}
                            onDismiss={this.dismissMessageBar}
                            dismissButtonAriaLabel="Close">{this.state.messageBarText}</MessageBar>
                    }


                    <div className={`search-form-dialog flex flex-column position-relative`}>

                        <div className={this.state.uorField.touched && !this.state.uorField.valid ? 'field error' : 'field'}>
                            <Label className='field-label' htmlFor={this.state.uorField.internalName} required={this.state.uorField.required}>{this.state.uorField.displayName}</Label>
                            <TagPicker styles={{ root: { paddingBottom: '20px' } }}
                                key={this.state.uorField.internalName}
                                componentRef={this.tagPickerRef}
                                getTextFromItem={getTextFromTagItem}
                                selectedItems={this.state.uorField.internalValue}
                                itemLimit={1}
                                pickerSuggestionsProps={this.tagPickerSuggestionsProps}

                                onResolveSuggestions={this.onTagPickerFilterChanged}
                                onItemSelected={this.onTagSelected}
                                onChange={this.onTagPickerItemsChange}
                                resolveDelay={400}
                            />
                            <Label className='field-label' htmlFor={this.state.visibilitaField.internalName} required={this.state.visibilitaField.required}>{this.state.visibilitaField.displayName}</Label>
                            <Dropdown
                                key={this.state.visibilitaField.internalName}
                                disabled={false}
                                placeholder="Seleziona un elemento"
                                options={this.state.visibilitaField.options!}
                                selectedKey={this.state.visibilitaField.internalValue}
                                onChange={this.onDropdownSelectChange}
                                onRenderTitle={this.onRenderDropodownTitle}
                                styles={{ root: { paddingBottom: '20px' } }}
                            />
                            <DynamicForm
                                fields={this.state.searchFormFields}
                                onInputChangedHandler={(newField) => { this.indiciInputChangedHandler(newField) }}
                                formMode={Indici_FormMode.Search}
                            />

                            {this.state.uorField.touched && !this.state.uorField.valid && <span className="error-message">Campo obbligatorio</span>}
                        </div>


                    </div>

                </Panel>


            </div>

        );
    }

}



export default connector(withRouter(checkRoles(SearchKQLComponentBase, RoleContext.Aoo)));




function getTextFromTagItem(tag: ITag): string {
    return tag.name as string;
}
